// Main application entrypoint for Vite
import Rails from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';

Rails.start();
ActiveStorage.start();

// Import styles
import '../stylesheets/reset.scss';
import '../stylesheets/application.scss';

// Vue 3 application
import { createApp } from 'vue';
import * as components from '../components';

document.addEventListener('DOMContentLoaded', () => {
  const appContainers = document.getElementsByClassName('vue-container');
  if (appContainers.length > 0) {
    for (const vc of appContainers) {
      const app = createApp({});
      for (const componentName in components) {
        const component = components[componentName];
        // Use the export name from index.js, converted to kebab-case for template usage
        const kebabName = componentName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        app.component(kebabName, component);
      }
      app.mount(vc);
    }
  }
});

console.log('Vite ⚡️ Rails loaded');
